module.exports = __webpack_public_path__ + "img/contact-cake-down.f1b1337a.png";